"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.string.includes.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var SingleImage = /*#__PURE__*/function (_Vue) {
  function SingleImage() {
    var _this;
    (0, _classCallCheck2.default)(this, SingleImage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, SingleImage, [].concat(args));
    (0, _defineProperty2.default)(_this, "pathImage", void 0);
    (0, _defineProperty2.default)(_this, "urlUpload", void 0);
    (0, _defineProperty2.default)(_this, "width", void 0);
    (0, _defineProperty2.default)(_this, "height", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "isProgressing", false);
    (0, _defineProperty2.default)(_this, "percentUpload", 0);
    return _this;
  }
  (0, _inherits2.default)(SingleImage, _Vue);
  return (0, _createClass2.default)(SingleImage, [{
    key: "token",
    get: function get() {
      return this.$tstore.state.user.token;
    }
  }, {
    key: "onProgress",
    value: function onProgress(event, file, fileList) {
      this.isProgressing = true;
      this.percentUpload = parseInt(event.percent.toFixed(0));
    }
  }, {
    key: "onError",
    value: function onError(err, file, fileList) {
      if (err.message) {
        this.$message.error(err.message);
      }
      this.isProgressing = false;
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(res) {
      this.$emit("upload:success", res.data.path);
      this.isProgressing = false;
    }
  }, {
    key: "beforeUpload",
    value: function beforeUpload(file) {
      var isJPG = file.type.includes("image");
      if (!isJPG) {
        this.$message.error("Image is not valid format!");
      }
      return isJPG;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String
})], SingleImage.prototype, "pathImage", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: "/staff/upload",
  type: String
})], SingleImage.prototype, "urlUpload", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 360
})], SingleImage.prototype, "width", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 180
})], SingleImage.prototype, "height", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], SingleImage.prototype, "disabled", void 0);
SingleImage = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], SingleImage);
var _default = exports.default = SingleImage;